import React from 'react';
import styled from "styled-components";

const StyledLabel = styled.label.attrs(props => ({
    fontSize: props.fontSize || props.theme.fontSize.small,
    color: props.color || props.theme.codanColors.black
}))`
    font-size: ${props => props.fontSize};
    color: ${props => props.color};
    line-height: 1.4;
`

const Label = ({isStrong, text, ...props}) => {
    return (
        <StyledLabel {...props}>
            {isStrong ? <strong>{text}</strong> : text}
        </StyledLabel>
    )
}

export default Label;

